
namespace Gamification.Gamification {

    @Serenity.Decorators.registerFormatter()
    export class SlickGridDomandaLivelloFormatter implements Slick.Formatter {

        @Serenity.Decorators.option()
        public dummy: string;

        format(ctx: Slick.FormatterContext) {

            var sOutput = "";

            if (ctx.value !== null) {
                var sLivello = ctx.value;

                if (sLivello === "Lieve") {
                    sOutput = '<div class="d-flex justify-content-center bg-light text-black">' +
                        sLivello +
                        '</div>';
                }
                else if (sLivello === "Moderata") {
                    sOutput = '<div class="d-flex justify-content-center bg-primary text-white">' +
                        sLivello +
                        '</div>';
                }
                else if (sLivello === "Alta") {
                    sOutput = '<div class="d-flex justify-content-center bg-warning text-white">' +
                        sLivello +
                        '</div>';
                }
                else if (sLivello === "Immediata") {
                    sOutput = '<div class="d-flex justify-content-center bg-danger text-white">' +
                        sLivello +
                        '</div>';
                }
                else {
                    sOutput = sLivello;
                }
            }

            return sOutput;
        }
    }
}